

























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ModalTemplateGlobalNotification extends Vue {
    @Prop({ default: false }) title!: string | false;
    @Prop() description!: string | false;

    open = false;

    mounted() {
        if (!this.getCookie("liberoo-session-notification")) {
            this.open = true;
        }
    }

    closePopup() {
        this.setCookie("liberoo-session-notification", "true");

        this.open = false;
    }

    setCookie(name: string, value: string, days?: number) {
        if (days) {
            var expires = "";
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
            document.cookie = name + "=" + value + expires + "; path=/";
        } else {
            document.cookie = name + "=" + value + "; path=/";
        }
    }

    getCookie(name: string) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
        }
        return null;
    }
}
